import CardSkeleton from './CardSkeleton';

// Card "Bancos" (Ajuste 09): assume o layout de destaque antes usado pelo
// "Saldo em Caixa" (fd-card-saldo) — saldo total em destaque — e mantém a
// quebra por banco (antes "Por Conta"). Fica na linha superior (fd-quick-row).
const BancosCard = ({ total, banks = [], loading }) => (
  <div className="fd-card blue fd-card-saldo fd-card-bancos">
    <div className="fd-card-label">Bancos</div>
    {loading ? (
      <CardSkeleton variant="value" />
    ) : (
      <>
        <div className="fd-card-value">{total}</div>
        <div className="fd-bancos-list">
          {banks.map((bank) => (
            <div className="fd-saldo-item" key={bank.name}>
              <span className="fd-saldo-bank">{bank.name}</span>
              <span className="fd-saldo-amount">{bank.amount}</span>
            </div>
          ))}
        </div>
      </>
    )}
  </div>
);

export default BancosCard;
